/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type labelCategoryRow_labels = ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly taskCount: number | null;
    readonly projectCount: number | null;
    readonly peopleCount: number | null;
    readonly " $fragmentRefs": FragmentRefs<"labelRow_label">;
    readonly " $refType": "labelCategoryRow_labels";
}>;
export type labelCategoryRow_labels$data = labelCategoryRow_labels;
export type labelCategoryRow_labels$key = ReadonlyArray<{
    readonly " $data"?: labelCategoryRow_labels$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"labelCategoryRow_labels">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "labelCategoryRow_labels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "peopleCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "labelRow_label"
    }
  ],
  "type": "Label"
};
(node as any).hash = '5fa515008c31079470fbe8e18f34c51a';
export default node;
